import React from 'react';
import { devices } from '../const/devices';

const useBreakpoint = (breakpoint: string) => {
	const [matches, setMatches] = React.useState(window.matchMedia(breakpoint).matches);

	React.useEffect(() => {
		const mediaQuery = window.matchMedia(breakpoint);
		const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

		mediaQuery.addEventListener('change', handler);

		return () => mediaQuery.removeEventListener('change', handler);
	}, [breakpoint]);

	return matches;
};

export const useIsDesktop = () => useBreakpoint(devices.desktop);
export const useIsLaptop = () => useBreakpoint(devices.laptop);
export const useIsLaptopL = () => useBreakpoint(devices.laptopL);
export const useIsTablet = () => useBreakpoint(devices.tablet);
export const useIsMobileL = () => useBreakpoint(devices.mobileL);
